import React from "react"
import {Typography} from "@mui/material"
import {TabbedFilterTitleContainer} from "./components"

interface StandardTabbedFilterTitleTypographyProps {
    children: string
}

export const StandardTabbedFilterTitleTypography = ({children}: StandardTabbedFilterTitleTypographyProps) => {
    return (
        <TabbedFilterTitleContainer variant="body1" component="span">
            <Typography variant="body1" component="span">
                {children}
            </Typography>
        </TabbedFilterTitleContainer>
    )
}

export default StandardTabbedFilterTitleTypography
